import {useContext} from 'react';

import {InternalContext} from '../../store/context';
export interface UseArrowFocusTrapArguments {}

export const useArrowFocusTrap = (props?: UseArrowFocusTrapArguments) => {
	const {
		activeDescendant,
		disabled,
		userDisabled,
		dispatch,
		activeIndex,
		clickKeysDisabled,
		disableNextScrollUpdate,
		keysDisabled,
		justClickedItem,
		returnToIndexOnFocus,
		sendNextFocusToPreviousElement,
		handleScrollIndexUpdate,
		handleItemClick,
		virtualListRef,
	} = useContext(InternalContext);

	return {
		activeDescendant,
		activeIndex,
		clickKeysDisabled,
		disableNextScrollUpdate,
		disabled,
		justClickedItem,
		keysDisabled,
		returnToIndexOnFocus,
		sendNextFocusToPreviousElement,
		dispatch,
		handleScrollIndexUpdate,
		handleItemClick,
		userDisabled,
		virtualListRef,
	};
};

export default useArrowFocusTrap;
